// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pl_a bhp_wx bhp_jb bhp_xl bhp_i bhp_j bhp_q bhp_vt bhp_et bhp_so bhp_sp bhp_eg","ReplyButton__icon":"pl_b bhp_rz"};